<template>
  <div>
    <header id="header" class="header" :class="classObject">
      <div class="top">
        <div class="nav-wrap">
          <img src="../assets/img/logo1.png" alt="" class="header-logo">
          <ul class="nav clearfix">
            <li :class="{'active' : activeType === 1 }">
              <router-link :to="{ name: 'Home', params: { status: 1 }}" @click="handleNavClick">首页</router-link>
            </li>
            <li :class="{'active' : activeType === 2 }">
              <router-link :to="{ name: 'Teacher', params: { status: 2 }}" @click="handleNavClick">老师</router-link>
            </li>
            <li :class="{'active' : activeType === 3 }">
              <router-link :to="{ name: 'Student', params: { status: 3 }}" @click="handleNavClick">学生</router-link>
            </li>
            <li :class="{'active' : activeType === 4 }">
              <router-link :to="{ name: 'Parent', params: { status: 4 }}" @click="handleNavClick">家长</router-link>
            </li>
            <li class="down-scan">
              <div class="app-down-warn" @mouseover="showScanErma=true" @mouseout="showScanErma=false">
                <img src="../assets/images/icon-phone.png" class="phone-icon" alt="">App下载
              </div>
              <div class="scan-erma" v-show="showScanErma">
                <img src="../assets/images/app-qr.png" alt="">
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--<div class="slogan"></div>-->
    </header>
  </div>
</template>

<script>
  export default {
    name: "Headers",
    data() {
      return {
        showScanErma: false,
        activeType: 1
      }
    },

    beforeMount() {
      this.getUrl();
      // console.log(this.activeType)
    },
    watch: {
      '$route'(to, from) {
        // 对路由变化作出响应...
        // console.log(333)
        this.activeType = this.$route.params.status || 1;
        //显示顶部
        window.scrollTo(0, 0)
        // let element = document.getElementById("header");
        // element.scrollIntoView(true);
      }
    },
    computed: {
      classObject: function () {
        return {
          'bg-home': this.activeType === 1,
          'bg-teacher': this.activeType === 2,
          'bg-student': this.activeType === 3,
          'bg-parent': this.activeType === 4,
        }
      }
    },
    methods: {
      getUrl(){
        // console.log(this.$route.path);
        // let url = window.location.href;
        if(this.$route.path.indexOf('/teacher')>-1){
          this.activeType = 2
        } else if(this.$route.path.indexOf('/student')>-1){
          this.activeType = 3
        }else if(this.$route.path.indexOf('/parent')>-1){
          this.activeType = 4
        }
      },
      //nav点击切换事件
      handleNavClick() {
        //埋点监控
        _hmt.push(['_trackEvent', '知心慧学', 'click', '导航栏tab点击切换事件']);
      },
    }
  }
</script>

<style lang="less" scoped>

  .header .nav ul li a.active::after {
    background: #3ea3fe;

  }

  .header {
    width: 100%;
    min-width: 1200px;
    height: 520px;
    color: #ffffff;

    .top {
      height: 60px;
      border-bottom: 1px solid rgba(255,255,255,0.5);
      .nav-wrap {
        width: 1200px;
        margin: 0 auto;
        line-height: 60px;
        font-size: 16px;
        .header-logo {
          vertical-align: middle;
        }
        .nav {
          display: inline-flex;
          margin-left: 70px;

          li {
            float: left;
            margin-left: 34px;
            height: 60px;
            a {
              color: #fff;
            }
          }
          .active {
            border-bottom: 2px solid #fff;
            box-sizing: border-box;
            a {
              font-size: 18px;
            }
          }
          .down-scan {
            position: relative;
            text-align: center;
            .app-down-warn {
              width: 120px;
              height: 40px;
              line-height: 40px;
              margin-top: 10px;
              cursor: pointer;
              &:hover {
                border-radius: 20px;
                background-color: rgba(255, 255, 255, 0.2);
              }
              .phone-icon {
                width: 14px;
                margin-right: 10px;
                vertical-align: middle;
              }
            }
          }
          .scan-erma {
            position: relative;
            margin-top: 12px;
            &:before {
              content: "";
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              border-bottom: 12px solid #fff;
              position: absolute;
              top: -12px;
              left: 50%;
              transform: translateX(-50%);
            }
            img {
              width: 120px;
            }
          }
        }
      }
    }

  }

  .bg-home {
    background: url("../assets/img/bg-header-banner.png") no-repeat center;
  }

  .bg-teacher {
    background: url("../assets/img/bg-header-teacher.png") no-repeat center;
  }

  .bg-student {
    background: url("../assets/img/bg-header-student.png") no-repeat center;
  }

  .bg-parent {
    background: url("../assets/img/bg-header-parent.png") no-repeat center;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?010bf9ca